import { request, BaseResponse } from '../api';
import type { ConversationStepResponse, AIRoleInScenario, RoleData } from './scenario';

// 管理端场景详情（字段参考 mentorai_admin 的步骤组件）
export interface AdminScenarioDetail {
  id: string;
  name: string;
  description?: string;
  scenario_cover?: string;
  tags?: string[];
  key_points?: string;
  status?: number | string;
  version?: string;
  version_description?: string;
  ai_roles_overall_description?: string;
  ai_roles?: AIRoleInScenario[];
  opening_dialogue_type?: number;
  opening_dialogue?: string;
  closing_dialogue?: string;
  conversation_steps?: ConversationStepResponse[];
  scoring_criteria_config?: any;
  scoring_knowledge_base_ids?: string[];
  practice_time_start?: string;
  practice_time_end?: string;
  min_practice_duration?: number;
  max_practice_duration?: number;
  max_practice_attempts?: number;
  completion_rule?: string;
  passing_score?: number;
  created_by?: { id: string; name: string };
  created_at?: string;
  updated_at?: string;
}

// 获取场景详情（管理端）
export async function getAdminScenarioDetail(
  scenarioId: string
): Promise<BaseResponse<AdminScenarioDetail | { data: AdminScenarioDetail }>> {
  return request<AdminScenarioDetail | { data: AdminScenarioDetail }>(
    `/scenarios/${scenarioId}`,
    {
      method: 'GET',
    }
  );
}

// 获取对话环节列表（管理端）
export async function getAdminConversationSteps(
  scenarioId: string
): Promise<BaseResponse<ConversationStepResponse[] | { data: ConversationStepResponse[] }>> {
  return request<ConversationStepResponse[] | { data: ConversationStepResponse[] }>(
    `/scenarios/${scenarioId}/conversation-steps`,
    {
      method: 'GET',
    }
  );
}